export function getCardNumberDigits(value = '') {
  return String(value).replace(/\D/g, '')
}

export function isAmexCardNumber(value = '') {
  return /^3[47]/.test(getCardNumberDigits(value))
}

export function isAmexCardBrand(value = '') {
  return String(value).toLowerCase() === 'amex'
}

export function isJaywanCardNumber(value = '') {
  return /^6\d{15}$/.test(getCardNumberDigits(value))
}

export function isValidCardNumber(value = '') {
  const cardNo = getCardNumberDigits(value)

  if (isJaywanCardNumber(cardNo)) {
    return true
  }

  if (isAmexCardNumber(cardNo)) {
    return /^\d{15}$/.test(cardNo)
  }

  return /^\d{16,19}$/.test(cardNo)
}
